import { useState } from "react";
import { Button, Modal } from "react-bootstrap";

import { FieldType } from "../../constants";
import {
	getMockPerms,
	removeMockPerms,
	setMockPerms,
} from "../../utils/localStorageUtils";
import { DataForm, setDataFormField } from "../dataForm/dataForm";

export const PermissionsModal = ({
	isModalShow,
	setModalShow,
}: {
	isModalShow: boolean;
	setModalShow: (b: boolean) => void;
}) => {
	const [perms, setPerms] = useState(getMockPerms() || {});

	const handleClose = () => {
		setModalShow(false);
	};

	const handleSubmit = () => {
		setMockPerms(perms);
		window.location.reload();
	};

	const handleClear = () => {
		removeMockPerms();
		window.location.reload();
	};

	const editPermissionsSettings = {
		action: "Manage Mock Permissions",
		fields: [
			[
				{
					field: "isOrgAdmin",
					title: "isOrgAdmin",
					type: FieldType.CHECKBOX,
				},
			],
			[
				{
					field: "isDeveloper",
					title: "isDeveloper",
					type: FieldType.CHECKBOX,
				},
			],
			[
				{
					field: "isBusinessManager",
					title: "isBusinessManager",
					type: FieldType.CHECKBOX,
				},
			],
			[
				{
					field: "isSubManager",
					title: "isSubManager",
					type: FieldType.CHECKBOX,
				},
			],
			[
				{
					field: "isTechSupport",
					title: "isTechSupport",
					type: FieldType.CHECKBOX,
				},
			],
			[
				{
					field: "isSiteAdmin",
					title: "isSiteAdmin",
					type: FieldType.CHECKBOX,
				},
			],
			[
				{
					field: "isSiteUser",
					title: "isSiteUser",
					type: FieldType.CHECKBOX,
				},
			],
		],
	};

	return (
		<Modal
			as={Modal.Dialog}
			centered
			show={isModalShow}
			onHide={handleClose}
		>
			<Modal.Header>
				<Modal.Title className="h6">
					Manage Mock Permissions
				</Modal.Title>
				<Button
					variant="close"
					aria-label="Close"
					onClick={handleClose}
				/>
			</Modal.Header>
			<Modal.Body>
				<DataForm
					currentFormData={perms}
					setFormData={setDataFormField(setPerms)}
					editorSetting={editPermissionsSettings}
				/>
			</Modal.Body>
			<Modal.Footer>
				<Button className="btn-warning ms-auto" onClick={handleClear}>
					Clear
				</Button>
				<Button className="btn-success ms-2" onClick={handleSubmit}>
					Save Perms
				</Button>
			</Modal.Footer>
		</Modal>
	);
};
